// Normalizes Cloudinary product images so grids show uniform, subject-aware crops.
// Non-Cloudinary URLs (local files, other hosts) pass through untouched.

const TRANSFORMS = {
  // Grid cards: exact 4:3 crop centered on the subject, sized for 2x displays.
  card: 'f_auto,q_auto,c_fill,g_auto,ar_4:3,w_800',
  // Square thumbnails (related products).
  thumb: 'f_auto,q_auto,c_fill,g_auto,ar_1:1,w_240',
  // Tall showcase cards crop via CSS object-cover; only cap size here.
  wide: 'f_auto,q_auto,c_limit,w_1400',
};

export function productImage(url, context = 'card', focus) {
  if (typeof url !== 'string' || !url.includes('res.cloudinary.com') || !url.includes('/upload/')) {
    return url;
  }
  let transform = TRANSFORMS[context] || TRANSFORMS.card;
  if (focus) {
    // Per-product override for images g_auto crops badly, e.g. focus="north".
    transform = transform.replace('g_auto', `g_${focus}`);
  }
  // Replace the existing transform segment (if any) between /upload/ and the version marker.
  return url.replace(/\/upload\/(?:[^/]+\/)?(v\d+\/)/, `/upload/${transform}/$1`);
}
